import { Badge, Skeleton } from '@radix-ui/themes';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import type { DrawClubType } from 'types/draw';

export const DrawChampionshipObject: React.FC<
  Partial<DrawClubType> & {
    loading?: boolean;
  }
> = ({ loading, competition_name, date, score, name, id }) => {
  const itemClassName = 'p-3 rounded-xl border border-solid border-neutral-neutral-2 hover:bg-accent-accent-3';
  const labelClassName = 'self-stretch text-neutral-neutral-8 text-sm font-medium tracking-normal';
  const contentClassName =
    'flex justify-between gap-2 text-wrap self-stretch text-neutral-neutral-alpha-12 text-base font-bold tracking-tighter';

  return (
    <Link className='w-full' to={`/tabellone/${id}`} key={id}>
      <div id='competition-scheduled' className={classNames('bg-white', itemClassName)}>
        <Skeleton loading={loading} className='h-auto w-auto'>
          <div id='name' className={contentClassName}>
            {name}
            <div className='flex flex-col items-end gap-2'>
              <Badge size='1' variant='solid' color='indigo'>
                COMP A SQUADRE
              </Badge>
            </div>
          </div>
        </Skeleton>
        <Skeleton loading={loading} className='h-auto w-auto'>
          <div id='competition_name' className='text-neutral-neutral-7 text-xs'>
            {competition_name}
          </div>
        </Skeleton>
        <div id='info' className='flex w-full justify-between pt-2'>
          <Skeleton loading={loading} className='h-auto w-auto'>
            <div id='date' className={labelClassName}>
              {date}
            </div>
          </Skeleton>
          <Skeleton loading={loading} className='h-auto w-auto'>
            <div id='players' className={labelClassName}>
              Risultato: <b>{score}</b>
            </div>
          </Skeleton>
        </div>
      </div>
    </Link>
  );
};

export default DrawChampionshipObject;
